import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell, ImagePlaceholder } from "@/components/site/SiteShell";
import { Section, CTA, Breadcrumbs } from "@/components/site/Sections";
import { BLOG_MAP } from "@/components/site/blog-posts";

const SLUG = "blog/oliefyr-til-varmepumpe";
const POST = BLOG_MAP[SLUG];

export const Route = createFileRoute("/blog/oliefyr-til-varmepumpe")({
  head: () => ({
    meta: [
      { title: `${POST.title} | Elektriker-Elektriker bloggen` },
      { name: "description", content: POST.excerpt },
      { property: "og:title", content: POST.title },
      { property: "og:description", content: POST.excerpt },
      { property: "og:type", content: "article" },
      { property: "og:url", content: `/${SLUG}` },
      { property: "article:published_time", content: POST.date },
      { property: "article:section", content: POST.category },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: POST.title },
      { name: "twitter:description", content: POST.excerpt },
    ],
    links: [{ rel: "canonical", href: `https://elektriker-elektriker.dk/${SLUG}` }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: POST.title,
        datePublished: POST.date,
        description: POST.excerpt,
        articleSection: POST.category,
        author: { "@type": "Organization", name: "Elektriker-Elektriker" },
        publisher: { "@type": "Organization", name: "Elektriker-Elektriker" },
        mainEntityOfPage: `/${SLUG}`,
      }),
    }],
  }),
  component: BlogPost,
});

function BlogPost() {
  return (
    <SiteShell>
      <Breadcrumbs items={[
        { label: "Forside", to: "/" },
        { label: "Blog", to: "/blog" },
        { label: POST.title },
      ]} />
      <Section>
        <article className="mx-auto max-w-3xl">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary">{POST.category}</span>
          <h1 className="mt-3 text-4xl md:text-5xl">{POST.title}</h1>
          <time className="mt-3 block text-sm text-muted-foreground" dateTime={POST.date}>
            {new Date(POST.date).toLocaleDateString("da-DK", { year: "numeric", month: "long", day: "numeric" })}
          </time>
          <div className="mt-8">
            <ImagePlaceholder label="Artikel-billede" ratio="aspect-[16/9]" />
          </div>
          <div className="prose prose-neutral mt-10 max-w-none space-y-5 text-[var(--ink)]/85">
            <p className="text-lg leading-relaxed text-[var(--ink)]/90">{POST.excerpt}</p>
            {POST.body.map((p, i) => (
              <p key={i} className="leading-relaxed">{p}</p>
            ))}
          </div>
          <div className="mt-10 rounded-2xl border border-border bg-secondary/40 p-6">
            <p className="text-sm text-[var(--ink)]/80">Brug for en autoriseret elektriker?</p>
            <Link to="/tilbud" className="mt-3 inline-flex h-11 items-center rounded-md bg-primary px-5 text-sm font-semibold text-primary-foreground hover:brightness-95">
              Indhent tilbud
            </Link>
          </div>
        </article>
      </Section>
      <CTA />
      <div className="h-10" />
    </SiteShell>
  );
}
